define((require) => {
    "use strict";

    var CustomJsAction         = require("shared/ui/experience/action/customJs/CustomJsAction"),
        CustomJsCollectionView = require("editor/ui/settings/integrations/customJs/CustomJsCollectionView"),
        EditCustomJsView       = require("editor/ui/settings/integrations/customJs/editCustomJs/EditCustomJsView"),
        ImprovedView           = require("editor/zbone/ImprovedView"),
        Lightbox               = require("shared/ui/common/Lightbox"),
        LoggedInUserState      = require("shared/ui/user/LoggedInUserState"),
        PrototypeAction        = require("ui/experience/action/PrototypeAction"),
        Permissions            = require("shared/security/Permissions"),
        template               = require("editor/ui/settings/integrations/customJs/CustomJsView.tpl");

    /**
     * This view is responsible for handling modifications to the prototypeActionCollection, so the
     * sub-views EditCustomJsView and CustomJsItemView trigger events on this class, when modifying
     * the collection.
     */
    return ImprovedView.extend("CustomJsView", {

        _customJsCollectionView: null,

        _editCustomJsView: null,

        template: template,

        templateHelpers: function() {
            return {
                cannotCreateNew: Permissions.Roles.MANAGER.cannot()
            };
        },

        className: "custom-js-view",

        ui: {
            newCustomJsButton: ".new-custom-js"
        },

        regions: {
            customJsList: ".custom-js-list"
        },

        events: {
            "click @ui.newCustomJsButton": "_newCustomJsClickHandler"
        },

        onShow: function() {
            this._customJsCollectionView = new CustomJsCollectionView({collection: this._getCustomJsActions()});
            this.listenTo(this._customJsCollectionView, "edit", this._showEditPopup);
            this.listenTo(this._customJsCollectionView, "refresh", this._refreshCustomJsList);
            this.customJsList.show(this._customJsCollectionView);
        },

        /**
         * @returns {PrototypeActionCollection}
         */
        _getCustomJsActions: function() {
            return LoggedInUserState.get("prototypeActionCollection").filterByType(CustomJsAction.TYPE);
        },

        _newCustomJsClickHandler: function() {
            var emptyJsAction = new PrototypeAction();
            emptyJsAction.set("action", new CustomJsAction());
            emptyJsAction.set("companyId", LoggedInUserState.get("company").get("id"));

            this._showEditPopup(emptyJsAction);
        },

        /**
         * Refreshes the actions list based on what's currently stored in Mongo.
         */
        _refreshCustomJsList: function() {
            return LoggedInUserState.get("prototypeActionCollection").fetch().done(() => {
                this._customJsCollectionView.collection.reset(this._getCustomJsActions().models);
            });
        },

        /**
         * Opens a lightbox with a custom js in it, to edit. If it is called
         * without a model, it will create a new one.
         *
         * @param {PrototypeAction<CustomJsAction>} [customJsPrototypeAction] - The model we wish to edit.
         */
        _showEditPopup: function(customJsPrototypeAction) {
            this._editCustomJsView = new EditCustomJsView({
                model: customJsPrototypeAction
            });

            // Need to update the list because a newly saved action gets actionId assigned by the
            // server on first save.
            this.listenTo(this._editCustomJsView, "saved", this._refreshCustomJsList);

            var lightboxOptions = {
                css: {
                    width: 800
                },
                editorEventProperties: {
                    modalType: "AddCustomJS",
                    triggerOrigin: "AddCustomJSModal"
                }
            };

            var lightbox = new Lightbox(this._editCustomJsView, lightboxOptions, this);
            lightbox.open();
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/integrations/customJs/CustomJsView.js